var $ = require("jquery");

var PastPassengerLookup = Backbone.View.extend({
  /**
   * The internal event listeners for the view.
   */
  events: {
    "click [data-past-passenger-lookup-trigger]": "displayLookup"
  },

  /**
   * This method handles the display of the lookup form
   *
   * @param event The event to handle
   */
  displayLookup: function(event) {
    var paxNumber = $(event.currentTarget).data("pastPassengerLookupTrigger");

    var start = null;
    var end = null;

    switch (this.$('[data-traveler-type="' + paxNumber + '"]').val()) {
      case "SRC":
        start = this.settings.date_ranges.senior.start;
        end = this.settings.date_ranges.senior.end;
        break;

      case "ADT":
        start = this.settings.date_ranges.adult.start;
        end = this.settings.date_ranges.adult.end;
        break;

      case "CHD":
        start = this.settings.date_ranges.child.start;
        end = this.settings.date_ranges.child.end;
        break;

      case "INF":
        start = this.settings.date_ranges.infant.start;
        end = this.settings.date_ranges.infant.end;
        break;
    }

    //capture the date formats received and what needs to be render

    var inputFormat = this.settings.date_format.input;
    var outputFormat = this.settings.date_format.output;

    // using moment to change the date to desired format
    start = moment(start, inputFormat).format(outputFormat);
    end = moment(end, inputFormat).format(outputFormat);

    this.renderLookup({
      lookupForm: true,
      paxNumber: paxNumber,
      date_of_birth_start: start,
      date_of_birth_end: end,
      gender: this.$('[data-traveler-gender="' + paxNumber + '"]').val(),
      title: this.$('[data-traveler-title="' + paxNumber + '"]').val(),
      first_name: this.$(
        '[data-traveler-first-name="' + paxNumber + '"]'
      ).val(),
      middle_name: this.$(
        '[data-traveler-middle-name="' + paxNumber + '"]'
      ).val(),
      last_name: this.$('[data-traveler-last-name="' + paxNumber + '"]').val(),
      date_of_birth: this.$(
        '[data-traveler-date-of-birth="' + paxNumber + '"]'
      ).val()
    });
  },

  /**
   * This method updates the lookup display based on the data
   *
   * @param data The data to use to render the view
   */
  renderLookup: function(data) {
    var content = this.templates.pastPassengerLookup(data);

    this.containers.pastPassengerLookup
      .removeClass("is-loading")
      .html($(content));

    this.Dialog = this.containers.pastPassengerLookup.component();
    this.Dialog.reflow().open();

    this.Dialog.currentModal.on(
      "submit",
      "[data-lookup-form]",
      function(event) {
        event.preventDefault();

        var form = $(event.currentTarget);

        this.lookupPastPassengers(form.attr("action"), form.serializeJSON());
      }.bind(this)
    );

    this.Dialog.currentModal.on(
      "click",
      "[data-past-passenger-lookup-result]",
      function(event) {
        this.updatePastPassenger(event);
      }.bind(this)
    );
  },

  lookupPastPassengers: function(url, data) {
    $.ajax({
      type: "GET",
      url: url,
      data: data,
      dataType: "html",
      cache: false,
      beforeSend: function() {
        this.Dialog.currentModal
          .find("[data-dialog-body]")
          .addClass("is-loading");
      }.bind(this),
      success: function(data) {
        this.Dialog.currentModal
          .find("[data-dialog-body]")
          .removeClass("is-loading")
          .html(data);
      }.bind(this),
      error: function() {
        this.renderLookup({
          lookupError: true
        });
      }.bind(this)
    });
  },

  updatePastPassenger: function(event) {
    var passenger = $(event.currentTarget).data("past-passenger-lookup-result");

    // to prevent data from getting cleared only populate fields that there is data for

    if (passenger.gender) {
      this.$('[data-traveler-gender="' + passenger.index + '"]').val(
        passenger.gender
      );
    }

    if (passenger.title) {
      this.$('[data-traveler-title="' + passenger.index + '"]').val(
        passenger.title
      );
    }

    if (passenger.first_name) {
      this.$('[data-traveler-first-name="' + passenger.index + '"]').val(
        passenger.first_name
      );
    }

    if (passenger.middle_name) {
      this.$('[data-traveler-middle-name="' + passenger.index + '"]').val(
        passenger.middle_name
      );
    }

    if (passenger.last_name) {
      this.$('[data-traveler-last-name="' + passenger.index + '"]').val(
        passenger.last_name
      );
    }

    let currentDateInput = this.$(
      '[data-calendar="date-of-birth-calendar-' + passenger.index + '"]'
    );

    if (passenger.date_of_birth) {
      var DOBCalendar = currentDateInput.component();

      DOBCalendar.setDate(
        passenger.date_of_birth
          ? moment
              .unix(passenger.date_of_birth)
              .utc()
              .endOf("day")
              .format("L")
          : null
      );
    }

    this.$(
      '[data-traveler-past-passenger-number="' + passenger.index + '"]'
    ).val(passenger.past_passenger_number);

    this.Dialog.close();
  },

  initialize: function() {
    this.settings = this.$el.data("settings");

    this.containers = {
      pastPassengerLookup: $(
        this.$("[data-past-passenger-lookup-modal]").html()
      )
    };

    this.templates = {
      pastPassengerLookup: Handlebars.compile(
        this.$('[data-template="past-passenger-lookup"]').html() || ""
      )
    };

    this.$el.loadComponents({ path: "cruise" });
  }
});

module.exports = PastPassengerLookup;
